import React from 'react';
import { Copy, Lock } from 'lucide-react';
import { VISIBILITY_HELP } from '../../model/entryMeta';

/** Phase 18 M6: "Internal (staff only)" toggle on note and incident forms */
export const VisibilityToggle: React.FC<{
  id: string;
  internal: boolean;
  onChange: (internal: boolean) => void;
  disabled?: boolean;
}> = ({ id, internal, onChange, disabled = false }) => (
  <div className="rounded border border-gray-200 bg-white/60 px-2 py-1.5">
    <label htmlFor={id} className="flex min-h-[44px] cursor-pointer select-none items-center gap-2">
      <input
        id={id}
        type="checkbox"
        role="switch"
        aria-checked={internal}
        aria-describedby={`${id}-help`}
        disabled={disabled}
        className={`h-5 w-5 rounded border-gray-300 text-slate-700 ${disabled ? 'cursor-not-allowed opacity-50' : ''}`}
        checked={internal}
        onChange={(e) => onChange(e.target.checked)}
      />
      <Lock size={14} className="text-slate-600" aria-hidden="true" />
      <span className="text-sm font-medium text-slate-800">Internal (staff only)</span>
    </label>
    <p id={`${id}-help`} className="ml-7 text-xs text-slate-600">{VISIBILITY_HELP}</p>
  </div>
);

/** Phase 18 M8: "Copy last" prefills the form from the latest entry of the same type in the visit */
export const CopyLastButton: React.FC<{ onClick: () => void; disabled?: boolean }> = ({ onClick, disabled = false }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className="inline-flex min-h-[44px] items-center gap-1 rounded border border-gray-300 bg-white px-3 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
  >
    <Copy size={16} aria-hidden="true" />
    Copy last
  </button>
);

/** Phase 18 M6: lock chip on internal entries */
export const InternalChip: React.FC = () => (
  <span
    data-testid="internal-chip"
    title={VISIBILITY_HELP}
    className="ml-2 inline-flex items-center gap-1 rounded border border-slate-300 bg-slate-100 px-1.5 py-0.5 text-xs font-medium text-slate-700"
  >
    <Lock size={11} aria-hidden="true" />
    Internal
  </span>
);
